import { render, staticRenderFns } from "./PhoneSlide.vue?vue&type=template&id=6bbe4126&scoped=true&"
import script from "./PhoneSlide.vue?vue&type=script&lang=js&"
export * from "./PhoneSlide.vue?vue&type=script&lang=js&"
import style0 from "./PhoneSlide.vue?vue&type=style&index=0&id=6bbe4126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbe4126",
  null
  
)

export default component.exports